/* Mobile-only placement of the Bitespeed WhatsApp chat button (#pt-wa-chat).
   PDP: pinned just below the product photo, right of the title / views pill, scrolls with the page.
   Collection: stays fixed and horizontally untouched; raised only as far as needed to clear the first-row quick-add "+".
   Desktop and other templates: no change. Uses position/top/bottom/z-index only, so it cannot shift layout. */
(function () {
  var MQ = '(max-width:749px)';
  if (!window.matchMedia || !matchMedia(MQ).matches) return;
  var path = location.pathname;
  var isPdp = /\/products\//.test(path);
  var isCollection = !isPdp && /\/collections\//.test(path);
  if (!isPdp && !isCollection) return;

  var ID = 'pt-wa-chat';
  var root = document.documentElement;
  var style = document.createElement('style');
  style.textContent = '@media ' + MQ + '{' +
    'html.bs-wa-pdp #' + ID + '{position:absolute!important;top:var(--bs-wa-top)!important;bottom:auto!important;margin-right:15px!important;z-index:1!important}' +
    'html.bs-wa-col #' + ID + '{bottom:var(--bs-wa-bottom)!important}}';
  document.head.appendChild(style);

  var timer = 0;
  var tail = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; place(); }, 50);
  }
  // re-check once scrolling has stopped (the sticky header finishes shrinking after the scroll starts)
  function scheduleTail() {
    schedule();
    clearTimeout(tail);
    tail = setTimeout(place, 400);
  }

  function place() {
    var f = document.getElementById(ID);
    if (!f) return;
    if (isPdp) placePdp(f); else placeCollection(f);
  }

  function textRects(el) {
    var out = [];
    if (!el || !document.createRange) return out;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var r = document.createRange();
    var n;
    while ((n = walker.nextNode())) {
      if (!/\S/.test(n.nodeValue) || /^(STYLE|SCRIPT)$/.test(n.parentNode.nodeName)) continue;
      r.selectNodeContents(n);
      var list = r.getClientRects();
      for (var i = 0; i < list.length; i++) if (list[i].width > 1 && list[i].height > 1) out.push(list[i]);
    }
    return out;
  }

  function placePdp(f) {
    var info = document.querySelector('.product__info-container');
    var media = document.querySelector('.product__media-wrapper');
    if (!info || !media) return;
    var h = f.offsetHeight || 45;
    var w = f.offsetWidth || 45;
    var vw = document.documentElement.clientWidth;
    var left = vw - 15 - w; // right edge sits 15px in from the screen edge (margin-right)
    var sy = window.pageYOffset;
    var mediaBottom = media.getBoundingClientRect().bottom;
    var top = mediaBottom + 8;

    // keep clear of the title text and the views pill: drop below any that sit in the button's column
    var blockers = textRects(info.querySelector('.product__title'));
    var pill = info.querySelector('.pdp-interest');
    if (pill) blockers.push(pill.getBoundingClientRect());
    for (var pass = 0; pass < 3; pass++) {
      for (var i = 0; i < blockers.length; i++) {
        var b = blockers[i];
        if (b.right > left - 8 && b.left < left + w + 8 && b.bottom > top - 4 && b.top < top + h + 4) top = b.bottom + 6;
      }
    }
    // never run into the EMI box
    var emi = info.querySelector('.snap-widget-buyonemi');
    if (emi) {
      var eb = (emi.closest('div') || emi).getBoundingClientRect();
      if (eb.width > 50 && top + h > eb.top - 4) top = Math.max(mediaBottom + 8, eb.top - 4 - h);
    }
    root.style.setProperty('--bs-wa-top', Math.round(top + sy) + 'px');
    root.classList.add('bs-wa-pdp');
  }

  function placeCollection(f) {
    if (window.pageYOffset > 0) return; // decided at the top of the page only, so it does not jump while scrolling
    var vh = window.innerHeight;
    var h = f.offsetHeight || 45;
    var baseBottom = parseFloat(f.style.bottom);
    if (!(baseBottom >= 0)) baseBottom = 70;
    var fl = f.getBoundingClientRect();
    var natTop = vh - baseBottom - h;
    var natBottom = vh - baseBottom;
    var pluses = document.querySelectorAll('.card-atc-plus');
    var need = 0;
    for (var i = 0; i < pluses.length; i++) {
      var r = pluses[i].getBoundingClientRect();
      if (r.top >= vh || r.bottom <= 0 || r.width < 2) continue;
      var hit = r.left < fl.right + 8 && r.right > fl.left - 8 && r.top < natBottom + 8 && r.bottom > natTop - 8;
      if (hit) need = Math.max(need, vh - (r.top - 12));
    }
    if (need > baseBottom) {
      need = Math.max(need, baseBottom + h); // lift by at least the icon's own height
      root.style.setProperty('--bs-wa-bottom', Math.round(need) + 'px');
      root.classList.add('bs-wa-col');
    } else {
      root.classList.remove('bs-wa-col');
    }
  }

  var mo = new MutationObserver(schedule);
  mo.observe(document.body, { childList: true, subtree: isPdp, characterData: isPdp });
  window.addEventListener('scroll', isPdp ? scheduleTail : schedule, { passive: true });
  window.addEventListener('resize', scheduleTail);
  window.addEventListener('load', function () {
    schedule();
    // the page keeps settling after load (images, category strip); re-check a few times
    [500, 1500, 3500].forEach(function (t) { setTimeout(place, t); });
    setTimeout(function () { mo.disconnect(); }, 10000);
  });
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(schedule);
    ro.observe(document.body);
    var info = document.querySelector('.product__info-container');
    if (isPdp && info) ro.observe(info);
  }
  schedule();
})();
